import { render, staticRenderFns } from "./EarningsCard.vue?vue&type=template&id=49f431f0"
import script from "./EarningsCard.vue?vue&type=script&lang=js"
export * from "./EarningsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports